export default __webpack_public_path__ + "static/media/growthClouds.56faebfe.jpg";